import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';
import { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import {
  streamingDegradedNotification,
  streamingInitializingNotification,
  streamingUnavailableNotification,
} from '@/App/NotificationZone/messages.ts';
import { useAppSelector } from '@/store/hooks.ts';
import { getStreamingConnectionStatus } from '@/store/streaming/slice.ts';

type HelpCenterLinkProps = {
  helpCenterLinkId?: string;
};

export const NotificationZone = () => {
  const connectionStatus = useAppSelector(getStreamingConnectionStatus);

  const messages = connectionStatus
    ? connectionStatus.status === 'connecting'
      ? streamingInitializingNotification
      : connectionStatus.status === 'disconnected'
        ? streamingUnavailableNotification
        : connectionStatus.status === 'idle' || !connectionStatus.isDegraded
          ? []
          : streamingDegradedNotification
    : [];

  return (
    <div
      className="d-flex justify-content-center fixed-top"
      style={{ top: 0, zIndex: 2000, left: '50%', transform: 'translateX(-50%)' }}
      data-e2e="notification-zone"
    >
      {messages.length > 0 &&
        messages.map((notif) => (
          <div
            key={notif?.messageId}
            className={`bg-${notif?.level} sgwt-account-center-tag p-1 alert-${notif?.level}`}
          >
            <FormattedMessage id={notif?.messageId} /> <HelpCenterLink helpCenterLinkId={notif?.helpCenterLinkId} />
          </div>
        ))}
    </div>
  );
};

const HelpCenterLink = ({ helpCenterLinkId }: HelpCenterLinkProps) => {
  const { sgwtHelpCenter } = useSgwtWidgets();
  const displayLink = useCallback(
    () => helpCenterLinkId && sgwtHelpCenter?.topic(helpCenterLinkId),
    [sgwtHelpCenter, helpCenterLinkId],
  );
  return helpCenterLinkId === undefined ? null : (
    <a className="alert-link" href="/" onClick={displayLink}>
      <FormattedMessage id="header.notification.linkToHelpCenter" />
    </a>
  );
};
